<template>
  <header class="header" :class="{ 'scrolled': isScrolled }">
    <div class="header-container">
      <div class="logo">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="28" height="28" class="logo-icon">
          <path fill="currentColor" d="M533.6 32.5C598.5 85.3 640 165.8 640 256s-41.5 170.8-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"/>
        </svg>
        <h1>FM<span>Radio</span></h1>
      </div>
      
      <nav class="nav">
        <ul>
          <li><a href="#" @click.prevent="navigateTo('home')" :class="{ 'active': activeSection === 'home' }">Home</a></li>
          <li><a href="#" @click.prevent="navigateTo('features')" :class="{ 'active': activeSection === 'features' }">Features</a></li>
          <li><a href="#" @click.prevent="navigateTo('download')" :class="{ 'active': activeSection === 'download' }">Download</a></li>
        </ul>
      </nav>
      
      <div class="mobile-menu" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
      </div>
      
      <div class="download-btn-container">
        <a href="#" @click.prevent="navigateTo('download')" class="download-btn">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="18" height="18">
            <path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32z"/>
          </svg>
          Download Now
        </a>
      </div>
    </div>
    
    <div class="mobile-nav" :class="{ 'open': menuOpen }">
      <ul>
        <li><a href="#" @click.prevent="navigateTo('home'); closeMenu()">Home</a></li>
        <li><a href="#" @click.prevent="navigateTo('features'); closeMenu()">Features</a></li>
        <li><a href="#" @click.prevent="navigateTo('download'); closeMenu()">Download</a></li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    scrollToSection: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      isScrolled: false,
      menuOpen: false,
      activeSection: 'home'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.observeSections();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.isScrolled = window.scrollY > 50;
    },
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.body.style.overflow = this.menuOpen ? 'hidden' : '';
    },
    closeMenu() {
      this.menuOpen = false;
      document.body.style.overflow = '';
    },
    navigateTo(sectionId) {
      console.log(`导航到: ${sectionId}`);
      
      // 使用props中的scrollToSection方法
      this.scrollToSection(sectionId);
      
      // 更新当前活动部分
      this.activeSection = sectionId;
    },
    observeSections() {
      const sections = ['home', 'features', 'download'];
      const observerOptions = {
        root: null,
        rootMargin: '-100px 0px -40% 0px',
        threshold: 0
      };
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            this.activeSection = id;
          }
        });
      }, observerOptions);
      
      // 使用setTimeout确保DOM已完全加载
      setTimeout(() => {
        sections.forEach(section => {
          const element = document.getElementById(section);
          if (element) {
            observer.observe(element);
          } else {
            console.warn(`无法找到ID为${section}的元素`);
          }
        });
      }, 1000);
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: rgba(15, 23, 42, 0.7);
  backdrop-filter: blur(10px);
  transition: all 0.4s ease;
  z-index: 1000;
  padding: 0 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.header.scrolled {
  background: rgba(15, 23, 42, 0.9);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  height: 70px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-container {
  max-width: 1280px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: white;
  text-decoration: none;
}

.logo-icon {
  color: #3b82f6;
  transition: transform 0.4s ease;
}

.header.scrolled .logo-icon {
  color: #60a5fa;
}

.logo:hover .logo-icon {
  transform: rotate(-15deg);
}

.logo h1 {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.logo span {
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding-left: 2px;
}

.nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 2.5rem;
}

.nav a {
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  font-size: 1.1rem;
  font-weight: 500;
  position: relative;
  transition: all 0.3s;
  padding: 0.5rem 0;
  cursor: pointer;
}

.nav a::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #3b82f6, #60a5fa);
  transition: width 0.3s ease;
  border-radius: 2px;
}

.nav a:hover,
.nav a.active {
  color: white;
}

.nav a:hover::after,
.nav a.active::after {
  width: 100%;
}

.download-btn-container {
  display: flex;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: rgba(59, 130, 246, 0.2);
  color: white;
  padding: 0.7rem 1.5rem;
  border-radius: 0.8rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s;
  border: 1px solid rgba(59, 130, 246, 0.3);
  font-size: 1rem;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.download-btn::after {
  content: "";
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(transparent, rgba(255, 255, 255, 0.2), transparent);
  transform: rotate(30deg);
  transition: transform 0.5s;
}

.download-btn:hover {
  background: rgba(59, 130, 246, 0.3);
  transform: translateY(-3px);
}

.download-btn:hover::after {
  transform: rotate(30deg) translate(80%, 0);
}

.header.scrolled .download-btn {
  background: linear-gradient(135deg, #3b82f6, #2563eb);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.3);
  border-color: transparent;
}

.mobile-menu {
  display: none;
  flex-direction: column;
  gap: 0.3rem;
  cursor: pointer;
  padding: 0.5rem;
}

.mobile-menu span {
  display: block;
  width: 28px;
  height: 3px;
  background-color: white;
  border-radius: 3px;
  transition: all 0.3s;
}

.mobile-nav {
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background: rgba(15, 23, 42, 0.98);
  backdrop-filter: blur(10px);
  padding: 2rem;
  transform: translateY(-100%);
  opacity: 0;
  transition: all 0.4s;
  visibility: hidden;
  z-index: 999;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.mobile-nav.open {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}

.mobile-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.mobile-nav a {
  color: white;
  font-size: 1.3rem;
  text-decoration: none;
  display: block;
  padding: 0.8rem 0;
  position: relative;
  font-weight: 500;
}

.mobile-nav a::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.5), transparent);
}

@media (max-width: 768px) {
  .nav {
    display: none;
  }
  
  .mobile-menu {
    display: flex;
  }
  
  .header-container {
    justify-content: space-between;
  }
  
  .download-btn-container {
    display: none;
  }
}
</style> 